import { connect } from "react-redux";
import {
  getCategoryChildLinks,
  getCategorySiblingLinks,
  getCategoryRelatedLinks
} from "../../../state/modules/category";
import CategoryHeaderLinks from "./CategoryHeaderLinks";

const mapStateToProps = state => ({
  childLinks: getCategoryChildLinks(state),
  siblingLinks: getCategorySiblingLinks(state),
  relatedLinks: getCategoryRelatedLinks(state)
});

export default connect(mapStateToProps)(CategoryHeaderLinks);
